// extracted by mini-css-extract-plugin
module.exports = {"pallete":"Pallete_pallete__JPMh1","label":"Pallete_label__JiU1R","resetButton":"Pallete_resetButton__Vqe2j","setButton":"Pallete_setButton__aC8uo"};